import React from 'react';
import { Form, Input } from 'antd';
import PictureInput from '../../components/media/PictureInput';
import MultiInputGroup from '../../components/media/MultiInputGroup';
import OrderedMedia from '../../components/media/OrderedMedia';

const ExerciseItem: React.FC<any> = ({ form, prefix, fullPrefix, dataType }: any) => {
  return (
    <div>
      <PictureInput form={form} prefix={prefix} fullPrefix={fullPrefix} />
      <Form.Item
        name={[...prefix, 'category']}
        label="分类"
        style={{ marginBottom: '16px' }}
        rules={[{ required: true, message: '不能为空' }]}
      >
        <Input placeholder="请输入分类名称" />
      </Form.Item>
      <Form.Item
        name={[...prefix, 'content']}
        label="运动介绍"
        style={{ marginBottom: '16px' }}
        rules={[{ required: true, message: '不能为空' }]}
      >
        <Input.TextArea rows={3} placeholder="请输入运动介绍" />
      </Form.Item>
      <MultiInputGroup type={dataType} name={[...prefix, "defaultMovement"]} addable removable divider
        item={(index: any) => <OrderedMedia index={index} form={form} listPathName={[...fullPrefix, "defaultMovement"]}>
          <Form.Item
            name={[index, 'title']}
            label="运动推荐名称"
            style={{ marginBottom: '16px' }}
            rules={[{ required: true, message: '不能为空' }]}
          >
            <Input placeholder="请输入运动推荐名称" />
          </Form.Item>
          <Form.Item
            name={[index, 'content']}
            label="运动推荐内容"
            style={{ marginBottom: '16px' }}
            rules={[{ required: true, message: '不能为空' }]}
          >
            <Input.TextArea rows={3} placeholder="请输入运动推荐内容" />
          </Form.Item>
        </OrderedMedia>}
      />
    </div>
  );
};
export default ExerciseItem;